import { render, staticRenderFns } from "./CarouselManage.vue?vue&type=template&id=3ff1fbe3&scoped=true"
import script from "./CarouselManage.vue?vue&type=script&lang=js"
export * from "./CarouselManage.vue?vue&type=script&lang=js"
import style0 from "./CarouselManage.vue?vue&type=style&index=0&id=3ff1fbe3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff1fbe3",
  null
  
)

export default component.exports